import { useContext, useCallback } from "react";

// context
import { SiteHeaderContext } from "./SiteHeaderProvider";
import { actionTypes } from "./store";
import rehydrateStateHelper from "./stateHelpers/rehydrateState.js";

// helpers
import { scrollWindowTo } from "core/SiteHeader/helpers.js";

// useSiteHeader
export const useSiteHeader = () => {
    const { state, dispatch, nonStateProps } = useContext(SiteHeaderContext);
    const {
        currentPage,
        isLoggedIn,
        currentUser,
        authMenuVisibilitiy
    } = nonStateProps;
    const { isCompact } = state;

    // Action Creators

    const setHasMounted = hasMounted => {
        dispatch({
            type: actionTypes.SET_HAS_MOUNTED,
            hasMounted
        });
    };

    /* Client-Side Hydrate State ---------------------------*/
    const rehydrateState = useCallback(() => {
        const stateProps = rehydrateStateHelper(
            currentPage,
            isLoggedIn,
            currentUser
        );
        dispatch({
            type: actionTypes.RESET_STATE,
            stateProps
        });
    }, [currentPage, isLoggedIn]);

    /* Header ---------------------------*/
    const setHeader = scrollY => {
        dispatch({
            type: actionTypes.SET_HEADER,
            scrollY
        });
    };

    // Animation
    const setAnimationSequence = (
        scrollY,
        animationSequenceRef,
        scrollDirectionRef
    ) => {
        dispatch({
            type: actionTypes.SET_ANIMATION_SEQUENCE,
            scrollY,
            animationSequenceRef,
            scrollDirectionRef
        });
    };

    const setAnimationIn = () => {
        dispatch({ type: actionTypes.SET_ANIMATION_IN });
    };

    const setAnimationOut = () => {
        dispatch({ type: actionTypes.SET_ANIMATION_OUT });
    };

    const setAnimationOverflow = isVisible => {
        dispatch({
            type: actionTypes.SET_ANIMATION_OVERFLOW_IS_VISIBLE,
            isVisible
        });
    };

    // general
    const setAuthMenuHasThreeColumns = isAdmin => {
        const authMenuHasThreeColumns =
            isAdmin && authMenuVisibilitiy.creatorTools.showMenu;

        dispatch({
            type: actionTypes.SET_AUTH_MENU_HAS_THREE_COLUMNS,
            authMenuHasThreeColumns
        });
    };

    const setHideBell = hideBell => {
        dispatch({
            type: actionTypes.SET_MAREKTING_MESSAGE_HIDE_BELL,
            hideBell
        });
    };

    const setMarketingMessageHtml = html => {
        dispatch({
            type: actionTypes.SET_MAREKTING_MESSAGE_HTML,
            html
        });
    };
    const setHamburgerModalIsOpen = hamburgerModalIsOpen => {
        dispatch({
            type: actionTypes.SET_HAMBURGER_MODAL_IS_OPEN,
            hamburgerModalIsOpen
        });
    };

    const setIsCompact = isCompact => {
        dispatch({
            type: actionTypes.SET_IS_COMPACT,
            isCompact
        });
    };

    const onFocusScrollUp = useCallback(() => {
        if (isCompact) scrollWindowTo(0);
    }, [isCompact]);

    return {
        ...nonStateProps,
        ...state,
        setHasMounted,
        rehydrateState,
        setHeader,
        setAnimationOverflow,
        setAnimationSequence,
        setAnimationIn,
        setAnimationOut,
        setAuthMenuHasThreeColumns,
        setHideBell,
        setMarketingMessageHtml,
        setHamburgerModalIsOpen,
        setIsCompact,
        onFocusScrollUp
    };
};
